import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const useTableHeightFromRef = (
  tableRef: React.RefObject<HTMLDivElement>
) => {
  const [tableHeight, _setTableHeight] = useState(0);
  const setTableHeight = useDebouncedCallback((height: number) => {
    _setTableHeight(height);
  }, 200);

  useEffect(() => {
    if (!tableRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setTableHeight(entry.contentRect.height - 3);
      }
    });

    resizeObserver.observe(tableRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return tableHeight;
};
